import httpClient from './httpClient';

const rechazarTarea = (pedido) => {    
    return httpClient.post('AppPedido/rechazarTarea', pedido);
};

export default rechazarTarea;